import * as React from 'react'
import {useTranslation} from 'react-i18next'
import {Hint} from '@/components/ui/hint'

/** Por debajo, un contador junto a un campo corto es ruido y la doctrina de texto lo prohíbe. */
const TOPE_DE_TEXTO_LARGO = 500

const AVISAR_DESDE = 0.9

/** Nunca truncar en silencio y sin contador permanente: avisa en el último 10 % y cuando `maxLength`
 * recorta un pegado, que el navegador hace sin avisar. */
export function useAvisoDeTope(maxLength: number | undefined, valor: unknown) {
  const [recortadoA, setRecortadoA] = React.useState<number | null>(null)
  const esLargo = maxLength !== undefined && maxLength >= TOPE_DE_TEXTO_LARGO
  const escrito = typeof valor === 'string' ? valor.length : 0

  const onPaste = React.useCallback(
    (e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (!esLargo || maxLength === undefined) return
      const campo = e.currentTarget
      const seleccion = (campo.selectionEnd ?? 0) - (campo.selectionStart ?? 0)
      const pegado = e.clipboardData.getData('text').length
      if (campo.value.length - seleccion + pegado > maxLength) setRecortadoA(maxLength)
    },
    [esLargo, maxLength]
  )

  // El aviso es del pegado: al seguir escribiendo ya sobra.
  const olvidarRecorte = React.useCallback(() => setRecortadoA(null), [])

  return {
    onPaste,
    olvidarRecorte,
    recortadoA,
    restantes: esLargo && maxLength !== undefined && escrito > maxLength * AVISAR_DESDE ? maxLength - escrito : null,
  }
}

export function AvisoDeTope({recortadoA, restantes}: {recortadoA: number | null; restantes: number | null}) {
  const {t} = useTranslation()
  if (recortadoA !== null) {
    return (
      <p className="text-xs text-destructive" data-testid="aviso-recortado">
        {t('campoTexto.recortado', {max: recortadoA})}
      </p>
    )
  }
  if (restantes === null) return null
  // `Hint` y no un `<p>` a mano: el check `doctrina_de_ux` cuenta como regresión cualquier copia de su piel.
  return <Hint testId="aviso-restantes">{t('campoTexto.restantes', {n: restantes})}</Hint>
}
